// extracted by mini-css-extract-plugin
module.exports = {"Header":"Logo_Header__3oZ_L","Logo":"Logo_Logo__dnLm1"};